import { PlexSnackbarFragment } from '../graphql/gen/types';
import { BaseAction } from './utils/baseAction';

type Payload = {
  visible: boolean;
  isSubscribed: boolean;
  plex: PlexSnackbarFragment;
};

export type ShowSnackbarAction = BaseAction<'showSnackbar', Payload>;

export const showSnackbar = (payload: Payload): ShowSnackbarAction => ({
  type: 'showSnackbar',
  payload,
});
